
export default function FilterButton(props){
    // Creates the filter buttons
    return (
        <button type = "button" aria-pressed = {props.isPressed} onClick = {() => props.setFilter(props.incident)}>
            <span>{props.incident}</span>
        </button>
    );
}